// @ts-nocheck

import { Component } from 'react';
import { connect } from 'react-redux';

import Animation from 'app/shared/modules/Animation';
import animationData from 'images/animations/alertAnimation.json';
import AppActions from 'app/shared/flux/actions/AppActions';
import Button from 'app/shared/core/Button';
import PropTypes from 'prop-types';
import './style.scss';
import { emitTrackOpenSearchAlertModalEvent } from 'app/shared/models/Clickstream/SearchAlertEvents';

class AlertButton extends Component {
  static propTypes = {
    isMobileFilter: PropTypes.bool,
  };
  static defaultProps = {
    isMobileFilter: false,
  };
  constructor(props) {
    super(props);
  }
  handleCreateSearchAlert = () => {
    emitTrackOpenSearchAlertModalEvent();
    dispatch(AppActions.toggleOverlay('createSearchAlert', true));
  };
  render() {
    return (
      <Button id="AlertButton" btnType="secondary" onClick={this.handleCreateSearchAlert} size="sm">
        <Animation
          aria-hidden="true"
          className="AlertButton-icon"
          shouldLoop
          shouldAutoplay
          animationData={animationData}
        />
        Get alerts
      </Button>
    );
  }
}

export default connect()(AlertButton);
